import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { map } from 'rxjs';
import { IMediaOriginType } from 'typings/doenkids/doenkids';
import { MediaOriginTypeStore, IMediaOriginTypeState } from './media-origin-type.store';

/**
 * The order the sources are offered in (ES-2379), by lower-case name. Other names follow in store order.
 * The ticket calls the last one "Overige beelden", the database has "Overige beeldbank": both rank last.
 */
const OPTION_ORDER = ['ai generated', 'ai modified', 'magnific', 'intern beeld', 'externe toestemming', ['overige beeldbank', 'overige beelden']];

const optionRank = (originType: IMediaOriginType) => {
  const name = originType.name?.trim().toLowerCase();
  const rank = OPTION_ORDER.findIndex((names) => [names].flat().includes(name));
  return rank === -1 ? OPTION_ORDER.length : rank;
};

@Injectable({ providedIn: 'root' })
export class MediaOriginTypeQuery extends QueryEntity<IMediaOriginTypeState, IMediaOriginType> {
  constructor(protected store: MediaOriginTypeStore) {
    super(store);
  }

  /**
   * All origin types, archived ones included, in the order they are offered.
   * Pickers hide the archived ones unless an image already has that source.
   */
  selectOptions() {
    return this.selectAll().pipe(
      map((originTypes) => [...originTypes].sort((a, b) => optionRank(a) - optionRank(b))),
    );
  }

  getTypeForId(id: number) {
    return this.getEntity(id);
  }

  getTypeForName(name: string) {
    return this.getAll().find((mediaOriginType) => mediaOriginType.name === name);
  }
}
